export const editAndReviewSetModalStyles = {
    modalWrapper: {
        position: 'fixed',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '40px',
        padding: '27px 80px 32px 80px',
        background: '#262626',
        borderRadius: '15px',
        width: '100%',
        maxWidth: '760px'
    }
}

export const tableteditAndReviewSetModalStyles = {
    modalWrapper: {
        position: 'fixed',
        left: '20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '40px',
        padding: '27px 80px 32px 80px',
        background: '#262626',
        borderRadius: '15px',
        width: '100%',
        maxWidth: '760px'
    }
}

export const mobileEditAndReviewStyles = {
    modalWrapper: {
        position: 'absolute',
        top: '124px',
        left: '0px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '40px',
        padding: '16px',
        background: 'none',
        borderRadius: '15px',
        width: '100%',
        maxWidth: '760px'
    }
}
